import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate";
import Button from "../../../component/visible/Button";
import {onScreenClick} from "../../../../common/report";
import Message from "../../../Message";

export default class EndcardBottom extends SingleOfferTemplate {
    constructor(...props) {
        super(...props)
        this.name = 'EndcardBottom';
    }

    adShowed(data) {
        super.adShowed()
        this.windowStartPoint = data && data.param || {}
    }
    initComponents() {
        super.initComponents()
        let _this = this;
        this.cta = new Button({
            type:"cta",
            long:"5",
            size:"4",
            text:_this.campaign.ctatext,
            background:"#689f38",
            onClick:function (event) {
                console.log("立即下载点击")
                onScreenClick.call(
                    _this,
                    event,
                    {
                        autoClick: false,
                        template: 'rv',
                        ctabanner: false,
                        campaign: _this.campaign,
                    }
                )
                Message.emitMessageToSuperView('onInstallBtnClick')
            }
        })
        this.cta.appendTo(document.querySelector('.install-box'));
        this.cta.show();
    }

    bindPageEvent() {
        super.bindPageEvent()

        // const closeBtn = document.querySelector('.mtgClose')
        // if (closeBtn) {
        //     closeBtn.addEventListener('click', () => {
        //         // App.onBroadcast(App.unit.id, 'readyToShow', {a:true})
        //         console.log('关闭按钮被点击-')
        //         this.hide()
        //         App.closeAd()
        //     }, false)
        // }
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
    }

    initSlots() {
        super.initSlots()
    }
    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.cta && this.cta.destory()
    }
}